import { FieldArrayItemType } from '@lib/components/ReactHookForm/types';

export default function getLastPosition(fields: FieldArrayItemType[]) {
  if (!fields?.length) return 0;
  const positions = fields
    .map(({ position }) => position)
    .sort((a, b) => a - b);
  return positions[positions.length - 1] + 1;
}
